import * as _ from 'lodash';
import { OrderDocumentResult } from 'orders-rest';

class ResultEditorController {
    private result: OrderDocumentResult;
    private files: File[];

    delete(file: File) {
        let index = _.findIndex(this.files, f => { return f === file; });
        this.files.splice(index, 1);
    }

    upload(files: File[]) {
        files.forEach(f => {
            this.files.push(f);
        });
    }
}

export const  ResultEditorComponent: angular.IComponentOptions = {
    controller:  ResultEditorController,
    template: require('./resultEditor.html'),
    bindings: {
        result: '<',
        files: '<'
    }
};

export const  ResultAcceptEditorComponent: angular.IComponentOptions = {
    controller:  ResultEditorController,
    template: require('./resultAcceptEditor.html'),
    bindings: {
        result: '<',
        files: '<'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/result/resultEditor.ts